/**
 * Vruchtvlees © 2007-2019
 *
 * Hi, welcome!
 *
 * This is the main Javscript file.
 * One script to rule them all!
 * Let's go and godspeed you!
 */

import $ from "jquery";
import jQuery from "jquery";

/** -------------------------- --------------
    Webpack Settings
 ---------------------------------------- */

let webpack = SETTINGS;

/** ----------------------------------------
    Helpers
 ---------------------------------------- */

import { getParentByTagName } from './helpers/Helpers'

/** ----------------------------------------
    Environment
 ---------------------------------------- */

/**
 * This class will check the current
 * environment of the website and stores
 * an object with information about the
 * current environment.
 */

import { Environment } from '@helper/Environment.js';
import { Log } from '@helper/Log.js';

const host = new Environment({
    localhost: 'vv-boilerplate',
    webpack: webpack
});

const log = new Log(host);

if(!host.info.environment.live) {
    log.section('VV', 'Environment');
    host.log();
}

/** ----------------------------------------
    Set Style Guide
 ---------------------------------------- */

/**
 * This section will set the VV Style Guide
 * as a default for at the index.html.
 *
 * You can mess around with the information
 * it will be displayed within the page.
 */

import { Style } from '@js/style/Style.js';

let info = {
    title: 'Vruchtvlees Digital Style Guide',
    intro: 'This style guide provides guidelines for the digital design as configured within the SASS stylesheets. It will automatically extend and change once you start working on the project. If certain elements or blocks should be left out these can be configured within the config.js file related to the style guide. It serves as a guide to quickly check what variables have been configured, what names they use and how the styling of a certain element has been affected within the stylesheet. Godspeed you!',
};

let config = {
    breakpoints: true,
    grid: true,
    typo: true,
    letters: true,
    colors: true,
    headings: true,
    text: true,
    content: true,
    font: true,
    links: true,
    tooltip: true,
    forms: true,
    lists: true,
    tables: true,
    buttons: true,
    icons: true
};

const style = new Style(info, config, webpack.config.production && webpack.config.guide && true);

if(!host.info.environment.live) {
    log.section('VV', 'Style');
    style.log();
}

/** ----------------------------------------
    Responsive Images
 ---------------------------------------- */

import { ResponsiveImages } from '@module/ResponsiveImages.js';

let responsive = new ResponsiveImages(style);

if(!host.info.environment.live) {
    log.section('VV', 'Responsive');
    responsive.log();
}

/** ----------------------------------------
    Select
 ---------------------------------------- */

import { Select } from '@module/Select';

for (let el of document.querySelectorAll('.form-select')) {
    new Select(el);
}

/** ----------------------------------------
    Video
 ---------------------------------------- */

import { Video } from './module/video';

const videosElems = document.querySelectorAll('.video');
const videos = [];

for (let videoEl of videosElems) {
    videos.push(new Video(videoEl));
}

/** ----------------------------------------
    Sticky Navigation
 ---------------------------------------- */

import { StickyNavigation } from './module/StickyNavigation';

new StickyNavigation();

/** ----------------------------------------
    Nav Toggle
 ---------------------------------------- */

let navToggleEl = document.querySelector('.js-nav-toggle');

navToggleEl.addEventListener('click', () => {
    document.body.classList.toggle('nav-open');
});

/** ----------------------------------------
    Show media
 ---------------------------------------- */

const showVideoElems = document.querySelectorAll('.js-show-video');

for (let showVideoEl of showVideoElems) {
    showVideoEl.addEventListener('click', () => {
        const targetEl = document.querySelector(showVideoEl.dataset.target);
        const videoEl = targetEl.querySelector('.video');
        targetEl.classList.add('is-active');
        showVideoEl.classList.add('is-hidden');

        videos.forEach(video => {
            if (video.el === videoEl)
                video.play();
        });
    });
}

/** ----------------------------------------
 Accordion
 ---------------------------------------- */

$(document).ready(function(){
    $('.js-accordion, .js-accordion--footer').each(function() {
        $(this).find('.js-accordion__answer, .js-accordion--footer__answer').hide().attr('hidden', true);
        $(this).find('.js-accordion__question, .js-accordion--footer__question').each(function() {
            let question = $(this);
            let answer = $(this).parent().find('.js-accordion__answer, .js-accordion--footer__answer');
            question.attr('aria-expanded', 'false');
            answer.attr('hidden', true);
            
            // Click handler
            $(this).on('click', function() {
                const expanded = question.attr('aria-expanded') === 'true';
                question.attr('aria-expanded', String(!expanded));
                if (expanded) {
                    answer.hide().attr('hidden', true);
                    question.removeClass('is-active');
                    answer.removeClass('is-active');
                } else {
                    answer.show().removeAttr('hidden');
                    question.addClass('is-active');
                    answer.addClass('is-active');
                }
            });
            
            // Keyboard handler
            $(this).on('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $(this).trigger('click');
                }
            });
        });
    });
});

/** ----------------------------------------
    Set home header height
 ---------------------------------------- */

 const setHeaderHeight = () => {
    let header = document.querySelector('.highlight-home');
    if (!header) {return}

    let leftCol = header.querySelector('.highlight-home__left');
    let rightCol = header.querySelector('.highlight-home__right');
    if (rightCol.offsetHeight < 186) {return}
    leftCol.style.height = `${rightCol.offsetHeight}px`
}

setHeaderHeight()

/** ----------------------------------------
 Homepage Slider
 ---------------------------------------- */

import slick from 'slick-carousel';

const headerSlider = document.querySelector('.highlight-home__mobile');

const setSlider = () => {
    if ($(window).width() < 1080 && headerSlider) {
        $('.highlight-home__mobile').slick({
            slidesToScroll: 1,
            mobileFirst: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            fade: false,
            autoplay: false,
            autoplaySpeed: 5000,
            arrows: true,
            dots: true,
            prevArrow: '<div class="slider__arrow slider__arrow--previous highlight-home__arrow--previous"></div>',
            nextArrow: '<div class="slider__arrow slider__arrow--next highlight-home__arrow--next"></div>',
        });
    }
}

const removeSlider = () => {
    if (!headerSlider) { return }
    $('.highlight-home__mobile').slick('unslick');
}

setSlider();

/** ----------------------------------------
 Header handle resize
 ---------------------------------------- */

let device = $(window).width() < 1080 ? 'mobile' : 'desktop';

window.onresize = function(event) {
    setHeaderHeight();
    let newDevice = $(window).width() < 1080 ? 'mobile' : 'desktop';
    if (!headerSlider) { return }

    // if view changes from desktop to mobile or vice-versa
    if (device !== newDevice) {
        newDevice == 'mobile' ? setSlider() : removeSlider();
        device = newDevice;
    }
};

/** ----------------------------------------
     Social Share
 ---------------------------------------- */

 import SocialShare from './module/SocialShare';

 const share = document.querySelectorAll('[data-module="social"]');

 [...share].map(el => el && new SocialShare(el));

 /** ----------------------------------------
    Overlay
 ---------------------------------------- */

$('.js-overlay-btn').each(function() {
    $(this).click(function() {
        $('.js-overlay').addClass('active');
        protectDetails();
    })
});

$('.js-overlay-close').click(function() {
    $('.js-overlay').removeClass('active');
})

 /** ----------------------------------------
    Protect emails + phone numbers
 ---------------------------------------- */

const spanify = (str) => {
    let chars = str.split('');
    chars.forEach((char, i) => {
        if (char === '.') {
            chars[i] = `<span class="dot"></span>`;
        } else {
            chars[i] = `<span>${char}</span>`;
        }
    })
    let result = chars.join('');
    return result;
}

const protectEmail = (email) => {
    let username = email.split('@')[0]
    let provider = email.split('@')[1]

    let result = `${spanify(username)}<span class="at"></span>${spanify(provider)}`;
    return result;
}

const protectPhone = (number) => {
    let result = '';
    let digits = number.split('');
    digits.forEach(digit => {
        for (let i = 0; i < Math.floor(Math.random()*100); i++) {
            result += `<span class="boop">${Math.floor(Math.random()*9)}</span>`;
        }
        result += `<span class="beep">${digit}</span>`;
        for (let i = 0; i < Math.floor(Math.random()*100); i++) {
            result += `<span class="boop">${Math.floor(Math.random()*9)}</span>`;
        }
    })

    return result;
}

const protectDetails = () => {
    let emails = document.querySelectorAll('.js-email');
    let phones = document.querySelectorAll('.js-phone');

    emails.forEach(email => {
        email.innerHTML = protectEmail(atob(email.getAttribute('data')));
    })

    phones.forEach(phone => {
        phone.innerHTML = protectPhone(atob(phone.getAttribute('data')));
    })
}

protectDetails();

/** ----------------------------------------
 Load more button
 ---------------------------------------- */

import LoadMore from './module/LoadMore';

const loadMore = document.querySelectorAll('.btn-load-more');

[...loadMore].forEach(el => el && new LoadMore(el));



/** ----------------------------------------
 Gallery Block
 ---------------------------------------- */

$(document).ready(() => {
    $('.gallery-block__slides').each(function() {
        const $leftArrow = $(this)
            .parent()
            .find('.gallery-block__arrows')
            .find('.gallery-block__arrow--left');

        const $rightArrow = $(this)
            .parent()
            .find('.gallery-block__arrows')
            .find('.gallery-block__arrow--right');

        $(this).slick({
            autoplay: true,
            autoplaySpeed: 7500,
            pauseOnHover: false,
            centerMode: false,
            slidesToShow: 1,
            arrows: true,
            prevArrow: $leftArrow,
            nextArrow: $rightArrow,
            dots: false,
            speed: 750,
            cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
            infinite: true,
            responsive: [
                {
                    breakpoint: parseInt(style.data.breakpoints['tablet-small'], 10),
                    settings: {
                        arrows: false,
                        centerMode: false,
                        cssEase: 'ease',
                    }
                }
            ]
        });
    });
});


/** ----------------------------------------
 Enlarge Image
 ---------------------------------------- */

import { EnlargeImage } from './module/EnlargeImage';
import { normalize } from "path";

const images = document.querySelectorAll('.js-enlarge');

for (let image of images) {
    if(image) new EnlargeImage(image);
}

/** ----------------------------------------
    Meesterbaan
 ---------------------------------------- */

import Meesterbaan from './module/Meesterbaan';

const meesterbaan = document.querySelector('.meesterbaan');
const loader = document.querySelector('.loader');

if(meesterbaan) {
    new Meesterbaan(meesterbaan, loader, host);
}

/** ----------------------------------------
    cleanUrl
 ---------------------------------------- */

 function cleanUrl(url) {
    var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
    }
    else {
        return url;
    }
}

const urls = document.querySelectorAll('.js-clean-url');

urls.forEach(url => {
    url.innerHTML = cleanUrl(url.innerHTML)
})

/** ----------------------------------------
    Search Overlau
---------------------------------------- */

import { SearchOverlay } from "./module/SearchOverlay";

new SearchOverlay();

/** ----------------------------------------
    Reset search button
---------------------------------------- */

document.querySelectorAll('button[type="reset"]').forEach(button => {
    const form = getParentByTagName(button, 'FORM');

    button.addEventListener('click', ev => {
        ev.preventDefault();
        form.reset();

        for (const element of form.elements) {
            const type = element.type.toLowerCase();

            if (['text', 'password', 'textarea', 'hidden'].includes(type))
                element.value = '';

            if (['radio', 'checkbox'].includes(type) && element.checked)
                element.checked = false;

            if (['select-one', 'select-multi'].includes(type))
                element.selectedIndex = -1;
        }
    });
});

/** ----------------------------------------
   Show More button
---------------------------------------- */
const collapse = (el, maxHeight) => {
    let content = el.previousElementSibling;
    let divHeight = content.offsetHeight;

    if (divHeight <= maxHeight) {
        el.style.display = 'none';
    } else {
        el.style.display = 'block';
        content.style.height = maxHeight + "px";
    }

    el.addEventListener("click", function () {
        this.classList.toggle("active");
        if (content.style.height === "100%") {
            content.style.height = maxHeight+"px";
            this.querySelector('.js-collapsible-text').innerHTML = 'Toon alle';
        } else {
            content.style.height = "100%";
            this.querySelector('.js-collapsible-text').innerHTML = 'Toon minder';
        }
    });
}

const contactShowMore = () => {
    let coll = document.getElementsByClassName("js-collapsible");

    for (let i = 0; i < coll.length; i++) {
        collapse(coll[i], 162)
    }
};
contactShowMore();

/** ----------------------------------------
   Readmore
---------------------------------------- */

function getLinkHtml() {
    return `
    <div class="button__container--flat mt-m mb-m">
        <div class="grid">
            <div class="grid__item--full grid__item--pad-small">
                <button class="btn-ghost--blue btn--small readmore__button">
                    <span class="js-collapsible-text"></span>
                    <span class="readmore__icon">
                        <span class="icon__arrow-simple-down--blue icon--small"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>`;
}

const readmore = (targetClass, closedHeight) => {
    let btnTxt = {
        more: 'Lees meer',
        less: 'Toon minder'
    };

    $(targetClass).each(function () {
        let height = $(this).height();
        let $this = $(this);
        if (height > closedHeight) {
            let btnsMarkup = getLinkHtml();
            $this.parent().append(btnsMarkup);
            $this.css('height', `${closedHeight}px`);

            let $button = $this.parent().find('.readmore__button');

            let $btnTextContainer = $button.find('.js-collapsible-text');
            if ($this.hasClass('js-readmore-form')) {
                btnTxt = '';
                $button.addClass('readmore__form');
            }

            $btnTextContainer.text(btnTxt.more);

            $button.click(function () {
                if ($this.hasClass('open')) {
                    $this.css('height', `${closedHeight}px`);
                    $btnTextContainer.text(btnTxt.more);
                    $this.removeClass('open');
                    $button.removeClass('open');

                } else {
                    $button.addClass('open');
                    $this.addClass('open');
                    $btnTextContainer.text(btnTxt.less);
                    $this.css('height', 'auto');
                }
            });

            const anchors = document.querySelectorAll('.js-anchor-from');
            if (anchors) {
                anchors.forEach(anchor => {
                    anchor.addEventListener('click', () => {
                        $this.css('height', 'auto');
                        $button.addClass('open');
                        $this.addClass('open');
                    });
                })
            }
        }
    })
};

if(window.location.hash === ''){
    readmore('.js-readmore', 500);
    if ($(window).width() < 768) {
        $('.js-readmore-mobile').addClass('readmore');
        readmore('.js-readmore-mobile', 180);
    }

    readmore('.js-readmore-form', 400);
    if ($(window).width() < 768) {
        $('.js-readmore-mobile').addClass('readmore');
        readmore('.js-readmore-form-mobile', 180);
    }
}

/** ----------------------------------------
    Forms
 ---------------------------------------- */

import { Form } from './module/Form';

const formElems = document.querySelectorAll('form');

for (let formEl of formElems) {
    new Form(formEl);
}

/** ----------------------------------------
    Scroll to comments
 ---------------------------------------- */

const getOffset = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
}

let scrollToCommentsBtns = document.querySelectorAll('.js-scroll-to-comments');

scrollToCommentsBtns.forEach(btn => {
    btn.addEventListener('click', function (event) {
        let target = document.querySelector('.js-comments');
        window.scrollTo({
            top: getOffset(target) - 90,
            left: 0,
            behavior: 'smooth'
          });
    }, false);
})

/** ----------------------------------------
    Newsletter form improvements
 ---------------------------------------- */

 /**
 * Apply the correct classes to the form, once it's loaded
 */

let newsFormContainer = document.getElementById('mpform2156');
let formContainer = document.getElementById('mpform1105');

const improveNewsForm = (newsForm) => {
    let submit = newsForm.querySelector('.submitButton');
    var textInput = newsForm.querySelectorAll('input[type=text]');
    submit.classList.add('btn-solid--yellow');
    submit.classList.add('mt-m');
    textInput.forEach(input => {
        input.classList.add('newsletter-block__input');
        input.setAttribute('placeholder', 'E-mailadres')
    });
};

const handleNewsForm = (container, formNum) => {
    if (!container) { return }

     /**
      * Prevent scrolling when mailplus newsletter is entering the page
      */

    let scrollY = window.scrollY;
    const scrollingFn = () => scrollY = window.scrollY;
    window.addEventListener('scroll', scrollingFn);

    document.addEventListener('focusin', function focusinFn(event) {
        if (event.target.parentNode.className === 'mpFormField') {
            event.target.disabled = true;
            window.scrollTo(0, scrollY);
            window.removeEventListener('scroll', scrollingFn);
            document.removeEventListener('focusin', focusinFn);

            setTimeout(() => {
                event.target.disabled = false;
            }, 2000);
        }
    }, false);

    /**
     * Observe mailplus newsletter coming in
     */

    const observer = new MutationObserver((mutations, observer) => {
        mutations.forEach(mutation => {
            if (mutation.addedNodes[0].id === formNum) {
                improveNewsForm(mutation.addedNodes[0]);
                observer.disconnect();
            }
        });
    });
    observer.observe(container.parentNode, { childList: true, subtree: true });

};

handleNewsForm(newsFormContainer, 'form2156');
handleNewsForm(formContainer, 'form1105');

/** ----------------------------------------
    Set main container size (footer always at bottom, if page is too short)
 ---------------------------------------- */

const setMainSize = () => {
    let main = document.querySelector('.main');
    let header = document.querySelector('.nav');
    let footer = document.querySelector('.footer');

    if (main && header && footer) {
        main.style.minHeight = `calc(100vh - ${header.offsetHeight + footer.offsetHeight}px)`
    }
}

$(document).ready(function(){
    setMainSize();
})

/** ----------------------------------------
    Horizontal / vertivcal gallery images (add class)
 ---------------------------------------- */

let galleries = document.querySelectorAll('.gallery-block');

galleries.forEach(gallery => {
    let imgs = gallery.querySelectorAll('img');
    imgs.forEach(img => {
        if (img.offsetWidth > img.offsetHeight) {
            img.classList.add('horizontal')
        } else {
            img.classList.add('vertical')
        }
    })
})

/** ----------------------------------------
   Hide empty cols to avoid layout issues (mobile) (add class)
 ---------------------------------------- */

const checkEmptyString = (str) => {
    if (!str.replace(/\s/g, '').length) {
      return true;
    } else {
        return false;
    }
}

const colLeft = document.querySelectorAll('.layout-3-col__aside-left');
const colRight = document.querySelectorAll('.layout-3-col__aside-right');

colLeft.forEach(col => {
    if(checkEmptyString(col.innerHTML)) {
        col.classList.add('empty')
    }
})

colRight.forEach(col => {
    if(checkEmptyString(col.innerHTML)) {
        col.classList.add('empty')
    }
})

/** ----------------------------------------
   Admin bar
 ---------------------------------------- */

const adminBarFunctionality = () => {
    let adminBar = document.querySelector('.admin-bar');
    if (!adminBar) { return };
    let adminBarClose = adminBar.querySelector('.admin-bar__close');

    adminBarClose.addEventListener('click', function (event) {
        adminBar.classList.add('admin-bar--closed');
        document.body.classList.remove('has-admin-bar')
    }, false);
}

adminBarFunctionality();

/** ----------------------------------------
 Edit
 ---------------------------------------- */

import FileInput from './module/FileInput';

const fileElems = document.querySelectorAll('.js-file');
[...fileElems].map(el => el && new FileInput(el));

/* ----------------------------------------
    Vue
---------------------------------------- */

import Vue from 'vue';

/* ----------------------------------------
    Comments
---------------------------------------- */

import Comments from './vue/Comments.vue';

const comments = document.querySelector('.js-comments-inner');

if(comments) {
    new Vue({
        el: '.js-comments-inner',
        render: h => h(Comments),
    })
}

/** ----------------------------------------
    Scroll to contacts
---------------------------------------- */

const scrollToContacts = () => {
    const button = document.querySelector('.js-scroll-contacts');
    const target = document.querySelector('.card-contact-person');

    if (button && target) {
        button.addEventListener('click', () => {
            target.scrollIntoView({behavior: "smooth", block: "start"});
        });
    } else {
        button && (button.style.opacity = 0);
    }
};

scrollToContacts();

/** ----------------------------------------
 Scroll to blocks
 ---------------------------------------- */

const scrollToBlocks = () => {
    const anchors = document.querySelectorAll('.js-anchor-from');
    const targets = document.querySelectorAll('.js-anchor-to');
    let elementHeight;
    const screenHeight = window.innerHeight;
    let position;
    let el;

    anchors.forEach(anchor => {
        anchor.addEventListener('click', () => {
            targets.forEach(target => {

                if (anchor.id === target.id
                    && anchor.classList.contains('js-anchor-from')
                    && target.classList.contains('js-anchor-to')) {

                    if (target.classList.contains('previous')) {
                        elementHeight = target.previousSibling.previousElementSibling.offsetHeight;
                        el = target.previousSibling.previousElementSibling
                    } else {
                        elementHeight = target.nextSibling.nextElementSibling.offsetHeight;
                        el = target.nextSibling.nextElementSibling
                    }

                    if (elementHeight >= screenHeight) {
                        position = 'start'
                    } else {
                        position = 'center'
                    }

                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: position,
                        inline: 'center'
                    });
                }
            });
        });
    });
};

scrollToBlocks();

/** ----------------------------------------
 File upload button
 ---------------------------------------- */

const btnUpload = $("#upload-input"),
    btnOuter = $(".upload-btn__outer");

if (btnUpload) {

    btnUpload.on("change", function (e) {
        let ext = btnUpload.val().split('.').pop().toLowerCase();

        if ($.inArray(ext, ['gif', 'png', 'jpg', 'jpeg']) == -1) {
            $(".upload-btn__error").text("Not an Image...");
        } else {
            $(".upload-btn__error").text("");
            btnOuter.addClass("file_uploading");
            setTimeout(function () {
                btnOuter.addClass("file_uploaded");
            }, 3000);

            let uploadedFile = URL.createObjectURL(e.target.files[0]);

            setTimeout(function () {
                $("#upload-btn-view").append('<img src="' + uploadedFile + '" />').addClass("show");
            }, 3500);
        }
    });

    $(".upload-btn__remove").on("click", function (e) {
        $("#upload-btn-view").removeClass("show");
        $("#upload-btn-view").find("img").remove();
        btnOuter.removeClass("file_uploading");
        btnOuter.removeClass("file_uploaded");
    });
}
